import type { AutoshipParams } from '@libs/common-next';

import {
    AutoShipUnitOfMeasure,
    getFrequencyInWeeks,
    getUomByValue,
} from '@libs/common-next';
import { LOCALIZED } from '@libs/core';
import { AddToCartType } from '../constants';

export const createAutoshipBody = ({
    productId,
    quantity,
    unitOfMeasure,
    frequencyAmount,
}: AutoshipParams) => {
    const unit = getUomByValue(unitOfMeasure);
    return {
        product_id: productId,
        quantity,
        c_isScheduleDelivLineItem: false,
        c_addToCartType: AddToCartType.STANDARD,
        c_isProductSubscribed: true,
        c_RecurringShipmentFrequency: getFrequencyInWeeks(
            frequencyAmount,
            unit
        ),
        inventory_id: LOCALIZED.webInventory,
        c_subscriptionData: JSON.stringify({
            rawFrequencyString: frequencyAmount.toString(),
            rawUnitOfMeasure: `${frequencyAmount}_${unitOfMeasure}`,
            frequency: frequencyAmount.toString(),
            isSubscribed: true,
            friendlyUnitOfMeasure: AutoShipUnitOfMeasure[unitOfMeasure],
        }),
    };
};
